// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2HM6F","row":"styles_row__25tXY"};